import { SearchStringPropertyValue } from './models'

export const stringIsPhoneNumber = (string: string): SearchStringPropertyValue => {
  const phoneNumberReg =
    /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/g
  const possiblePhoneNumberReg = /^([0-9\-()+#\s])*([0-9])+([0-9\-()+#\s])*$/g
  if (phoneNumberReg.test(string)) {
    return SearchStringPropertyValue.TRUE
  }
  if (possiblePhoneNumberReg.test(string)) {
    return SearchStringPropertyValue.POSSIBLE
  }
  return SearchStringPropertyValue.FALSE
}

export const stringContainsDigits = (string: string): SearchStringPropertyValue => {
  const stringWithoutWhitespace = string.replace(/\s+/g, '')
  const containsOnlyDigitsReg = /^[0-9]+$/g
  const containsDigitsReg = /[0-9]/g
  if (containsOnlyDigitsReg.test(stringWithoutWhitespace)) {
    return SearchStringPropertyValue.ALL
  }
  if (containsDigitsReg.test(stringWithoutWhitespace)) {
    return SearchStringPropertyValue.SOME
  }
  return SearchStringPropertyValue.NONE
}

export const stringContainsLetters = (string: string): SearchStringPropertyValue => {
  const stringWithoutWhitespace = string.replace(/\s+/g, '')
  const containsOnlyLettersReg = /^[a-zA-Z]+$/g
  const containsLettersReg = /[a-zA-Z]/g
  if (containsOnlyLettersReg.test(stringWithoutWhitespace)) {
    return SearchStringPropertyValue.ALL
  }
  if (containsLettersReg.test(stringWithoutWhitespace)) {
    return SearchStringPropertyValue.SOME
  }
  return SearchStringPropertyValue.NONE
}

export const stringContainsSpecialCharacters = (string: string): SearchStringPropertyValue => {
  const stringWithoutWhitespace = string.replace(/\s+/g, '')
  const containsOnlySpecialCharactersReg = /^[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]+$/g
  const containsSpecialCharactersReg = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/g
  if (containsOnlySpecialCharactersReg.test(stringWithoutWhitespace)) {
    return SearchStringPropertyValue.ALL
  }
  if (containsSpecialCharactersReg.test(stringWithoutWhitespace)) {
    return SearchStringPropertyValue.SOME
  }
  return SearchStringPropertyValue.NONE
}

export const stringWordCount = (string: string) => {
  const words = string.match(/\S+/g)
  if (words) {
    return words.length
  }
  return 0
}

export const stringContainsEmail = (string: string): SearchStringPropertyValue => {
  const containsOnlyEmail = /^([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)+$/g
  const containsEmail = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g
  if (containsOnlyEmail.test(string)) {
    return SearchStringPropertyValue.ALL
  }
  if (containsEmail.test(string)) {
    return SearchStringPropertyValue.SOME
  }
  return SearchStringPropertyValue.NONE
}

export const stringIsMeetingUrl = (string: string): SearchStringPropertyValue => {
  const meetingUrlReg = /^(https?:\/\/|)(www\.|)(meet\.goto\.com|gotomeet\.me|app\.goto\.com\/meeting|)\/?\/(\d{9})+$/g
  const possibleMeetingUrl =
    /^(https?:\/\/|)(www\.|)(meet\.goto\.com|gotomeet\.me|app\.goto\.com\/meeting|)\/?\/[/a-zA-Z_\-\d]+$/g

  if (meetingUrlReg.test(string)) {
    return SearchStringPropertyValue.TRUE
  }
  if (possibleMeetingUrl.test(string)) {
    return SearchStringPropertyValue.POSSIBLE
  }
  return SearchStringPropertyValue.FALSE
}

export const stringIsMeetingId = (string: string): SearchStringPropertyValue => {
  const nineDigitStringReg = /^\d{9}$/g
  const containsOnlyDigitsReg = /^[0-9]+$/g
  if (nineDigitStringReg.test(string)) {
    return SearchStringPropertyValue.TRUE
  }
  if (containsOnlyDigitsReg.test(string)) {
    return SearchStringPropertyValue.POSSIBLE
  }
  return SearchStringPropertyValue.FALSE
}
